"use client";

import HeaderBackground from "@/components/ui/header-background";

const PrivacyHeader = () => {
  return <HeaderBackground type="black" />;
};

export default PrivacyHeader;
